<template>
  <div :class="['content', programStyle]" v-if="form">
    <div class="appeal-container">
      <div class="title">{{ $t('form-review-tracking') }}</div>
      <div class="flex-column">
        <div class="flex-row form-info">
          <span>{{ $t('dealer-selectedform-dealername-0', [selectedForm.dealerName]) }}</span> |
          <span>{{ $t('dealer-code-selectedform-entity-0', [selectedForm.entity]) }}</span>
        </div>
        <div class="flex-row form-info">
          <span>{{ $t('bc-selectedform-bc-0', [selectedForm.bc]) }}</span> |
          <span>{{ $t('sales-district-form', [selectedForm.salesDistrict]) }}</span>
          |
          <span>{{ $t('service-district-form', [selectedForm.serviceDistrict]) }}</span>
        </div>
      </div>
      <FieldAppealDataTable :headings="fieldReviewTH" :rows="stepRows" :perPage="rowCount" :page="currentPage" />
    </div>
    <div class="form-container" v-if="appeals">
      <div class="item-container" v-for="appeal in appeals" :key="appeal.dialId">
        <div class="left-container flex-column">
          <div :class="['circle', appeal.dialColor]">
            <div class="inner" v-if="appeal.dialResultText">
              {{ appeal.dialResultText }}
            </div>
          </div>
        </div>
        <div class="right-container flex-column">
          <div class="subtitle">{{ appeal.dialTitle }}</div>
          <div>{{ $t('supporting-documents-0') }}</div>
          <div v-if="appeal.uploads">
            <div class="support-docs" v-for="upload in appeal.uploads" :key="upload.key">
              <span v-if="upload.label === appeal.dialTitle">{{ upload.originalFilename }}</span>
              <a v-if="upload.label === appeal.dialTitle" class="relative" target="_blank" :href="upload.url">
                <img class="download-icon" src="@/assets/img/download-arrow.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container" v-for="status in stepRows" :key="status.stepName">
        <div class="bottom-info bottom-border" v-if="status.id && status.stepName !== 'Dealer'">
          <span class="info">{{ status.stepName }}</span>
          <div class="dial">
            {{ $t('select-one') }}
            <div class="flex-row radio-container">
              <button :class="status.result === 'Approved' ? 'radio-selected' : 'radio'">
                <div v-if="status.result === 'Approved'" class="selected"></div>
              </button>
              <span>{{ $t('approve') }}</span>
            </div>
            <div class="flex-row radio-container">
              <button :class="status.result === 'Declined' ? 'radio-selected' : 'radio'">
                <div v-if="status.result === 'Declined'" class="selected"></div>
              </button>
              <span>{{ $t('deny') }}</span>
            </div>
          </div>
          <span class="label">Reason:</span>
          <textarea readonly v-model="status.reason" />
          <div class="flex-row input-info">
            <div class="flex-column">
              <span class="label">Name:</span>
              <input readonly v-model="status.name" />
            </div>
            <div class="flex-column">
              <span class="label">Title:</span>
              <input readonly v-model="status.title" />
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-container">
        <div class="bottom-info" v-if="form.permissions[0].canSubmit">
          <div class="dial">
            {{ $t('select-one') }}
            <div class="flex-row radio-container">
              <button :class="result === 'Approved' ? 'radio-selected' : 'radio'" @click="result = 'Approved'">
                <div v-if="result === 'Approved'" class="selected"></div>
              </button>
              <span>{{ $t('approve') }}</span>
            </div>
            <div class="flex-row radio-container">
              <button :class="result === 'Declined' ? 'radio-selected' : 'radio'" @click="result = 'Declined'">
                <div v-if="result === 'Declined'" class="selected"></div>
              </button>
              <span>{{ $t('deny') }}</span>
            </div>
          </div>
          <span class="label">Reason:</span>
          <GInput type="textarea" v-model="reason" maxlength="1000" :showCount="true"></GInput>
          <div class="flex-row input-info">
            <div class="flex-column">
              <span class="label">Name:</span>
              <input readonly v-model="name" />
            </div>
            <div class="flex-column">
              <span class="label">Title:</span>
              <input v-model="title" />
            </div>
            <div class="flex-column">
              <span class="label">Signature:</span>
              <VueSignaturePad id="signature" width="500px" height="100px" ref="signaturePad" :options="options" />
              <span class="signature-confirmation" v-if="signature">{{ $t('signature-saved') }}</span>
              <div class="flex-row signature-buttons">
                <button @click="saveSignature" class="small-btn">{{ $t('save') }}</button>
                <button @click="clearSignature" class="small-btn right-btn">{{ $t('clear') }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="button-container">
          <button class="small-btn" @click="exit">{{ $t('exit') }}</button>
          <button
            v-if="form.permissions[0].canSubmit || form.permissions[0].canOverride"
            value="save"
            @click="save"
            :class="[fullValidationCheck ? '' : 'disabled', 'small-btn']"
          >
            {{ $t('submit') }}
          </button>
          <div v-if="invalidPermissions">
            {{ $t('contact-admin') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css';
import FieldAppealDataTable from '@/components/FieldAppealDataTable.vue';
import GInput from '@/components/GComponents/GInput.vue';
import { mapState } from 'vuex';
import fieldReviewTH from '@/utils/tableHeaders/fieldReviewTH';

export default {
  name: 'FieldWagoneerReview',
  components: { FieldAppealDataTable, GInput },
  props: {
    selectedForm: {
      type: Object,
    },
  },
  data() {
    return {
      value: 'appeals',
      date: new Date(),
      status: null,
      form: null,
      rowCount: 7,
      currentPage: 1,
      stepRows: [],
      formInfo: null,
      appeals: [],
      formId: null,
      result: null,
      reason: null,
      title: null,
      options: {
        penColor: '#000000',
      },
      signatureSaved: false,
      signature: null,
      invalidPermissions: false,
      fieldReviewTH: fieldReviewTH(),
    };
  },
  methods: {
    save() {
      if (this.fullValidationCheck) {
        const { result } = this;

        const params = {
          formId: this.selectedForm.formId,
          result,
          fieldSignature: this.signature,
          reason: this.reason,
          title: this.title,
        };
        this.submitFieldForm(params);
      }
    },
    submitFieldForm(params) {
      this.$store
        .dispatch('updateForm', params)
        .then((res) => {
          if (res === 'invalid_permissions') {
            this.invalidPermissions = true;
          } else {
            this.exit();
          }
        })
        .catch(() => {});
    },
    exit() {
      this.$emit('exit');
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (!isEmpty) {
        this.signature = data;
      }
    },
    clearSignature() {
      this.$refs.signaturePad.undoSignature();
      this.signature = null;
    },
    getForm() {
      const loader = this.$loading.show();
      const { formId } = this.selectedForm;

      this.$store
        .dispatch('getForm', { formId })
        .then((res) => {
          if (res) {
            this.form = res;
            this.form.steps.forEach((step) => {
              if (step.status.id) {
                this.$set(step.status, 'stepName', step.stepName);
                this.stepRows.push(step.status);
              } else {
                this.stepRows.push({
                  stepName: step.stepName,
                  result: '',
                });
              }
            });
            this.form.items.forEach((item) => {
              this.appeals.push(item);
            });
          }
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  computed: {
    ...mapState('global', ['programStyle']),
    name() {
      const user = JSON.parse(localStorage.getItem('stellantis-user'));
      const fullName = `${user.firstName} ${user.lastName}`;

      return fullName;
    },
    fullValidationCheck() {
      if (this.title && this.reason && this.signature && this.result) {
        return true;
      }
      return false;
    },
  },
  watch: {},
  created() {
    this.getForm();
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #000000;
  text-align: left;
  .link {
    color: #243882;
  }
}
.title-container {
  margin-left: 30px;
  margin-top: 30px;
}
.title {
  margin-bottom: 24px;
  color: #243882;
  font-size: 21px;
}
.item-container {
  display: flex;
  margin: 0 30px 20px 30px;
}
.right-container {
  width: 100%;
  margin-left: 10px;
  font-size: 14px;
  input {
    height: 100px;
    width: initial;
    background: $input-background;
    border: none;
    margin-bottom: 20px;
  }
  .support-docs {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
}
.left-container {
  min-width: 80px;
}
.subtitle {
  font-size: 18px;
  margin-bottom: 30px;
}
.description {
  margin-bottom: 10px;
}
.bottom-container {
  margin: 0px 0 20px 30px;
  display: flex;
  flex-direction: column;
}
.bottom-info {
  display: flex;
  flex-direction: column;
  margin-right: 30px;
  .info {
    margin-bottom: 15px;
  }
  input {
    width: initial;
    background: $input-background;
    border: 1px solid $border;
    margin-bottom: 20px;
    margin-right: 30px;
    &:read-only {
      cursor: default;
      background: $input-readonly !important;
    }
    width: 250px;
  }
  .dial {
    margin-bottom: 40px;
    display: flex;
    align-items: center;
  }
  .label {
    margin-bottom: 20px;
  }
}
.button-container {
  display: flex;
  margin-top: 40px;
  align-items: center;
  justify-content: center;
  button {
    margin-right: 30px;
  }
}
.date {
  width: 160px;
  background: $input-background;
  border: none;
  margin-bottom: 20px;
  margin-right: 20px;
  padding: 13px 0px 13px 20px;
}

#signature {
  background: $input-background;
  border: 1px solid $border;
}
.signature-confirmation {
  font-size: 12px;
}
.signature-buttons {
  justify-content: center;
  margin-top: 20px;
  .right-btn {
    margin-left: 20px;
  }
}

.appeal-container {
  margin: 40px 30px 20px 30px;
  .form-info {
    margin-bottom: 20px;
    span:not(:first-child) {
      margin: 0 15px;
    }
    span:first-child {
      margin-right: 15px;
    }
  }
}
.radio {
  background: white !important;
}
.radio-selected {
  background: white !important;
}
</style>
